import React, { useCallback } from 'react';
import { Graphics } from '@pixi/react';

const FreehandDraw = ({ 
  shape, 
  isSelected, 
  onUpdate, 
  onSelect, 
  stageRef,
  isBlueprintMode = false
}) => {
  const drawFreehandPath = useCallback((g) => {
    if (!shape || !shape.points || shape.points.length < 2) return;
    
    g.clear();
    g.interactive = true;
    g.cursor = 'pointer';
    
    // Set line style based on highlighter properties
    const lineColor = isBlueprintMode ? 0xffffff : (shape.color || 0xFFEB3B); // White in blueprint, default to yellow
    const lineWidth = shape.lineWidth || 8; // Thick like a highlighter
    const alpha = shape.alpha || 0.7; // Semi-transparent like a highlighter
    
    g.lineStyle(lineWidth, lineColor, alpha);
    
    // Draw the freehand path
    if (shape.points.length >= 2) {
      g.moveTo(shape.points[0].x, shape.points[0].y);
      
      // Use smooth curves for better appearance
      for (let i = 1; i < shape.points.length; i++) {
        const point = shape.points[i];
        
        if (i === 1) {
          // First segment - direct line
          g.lineTo(point.x, point.y);
        } else {
          // Smooth curve through points
          const prevPoint = shape.points[i - 1];
          const nextPoint = shape.points[i];
          
          // Calculate control points for smooth curve
          const controlX = (prevPoint.x + nextPoint.x) / 2;
          const controlY = (prevPoint.y + nextPoint.y) / 2;
          
          g.quadraticCurveTo(controlX, controlY, nextPoint.x, nextPoint.y);
        }
      }
    }
    
    // Add selection indicator
    if (isSelected) {
      g.lineStyle(2, 0x4a90e2, 1);
      g.drawRect(
        shape.bounds.x - 5, 
        shape.bounds.y - 5, 
        shape.bounds.width + 10, 
        shape.bounds.height + 10
      );
    }
  }, [shape, isSelected, isBlueprintMode]);
  
  const handleClick = useCallback((event) => {
    event.stopPropagation();
    onSelect && onSelect();
  }, [onSelect]);
  
  if (!shape || !shape.points || shape.points.length < 2) return null;
  
  return (
    <Graphics
      draw={drawFreehandPath}
      interactive={true}
      cursor="pointer"
      pointerdown={handleClick}
      click={handleClick}
    />
  );
};

export default FreehandDraw; 